<div class="row m-0 h-v text-center">
  <div class="desc-title bold neutral-00">Contattaci</div>
</div>

<div class="container-fluid grid">
  <div class="row neg p-4 p-xl-5">
    <div class="col-lg-6 col-md-12 mb-4">
      <div class="f-card m-auto p-5 p-xs-5">
        <p class="blue-50 mb-3 w-700">Easycode</p>
        <p class="w-700" style="width: fit-content"
          ><a
            href="https://goo.gl/maps/SMfHbXb6hUmntzaQA"
            class="text-decoration-none text-reset"
            target="_blank"
            ><img
              src="../../../assets/img/Location.png"
              class="icon-footer"
              alt="location"
            />Viale Elvezia 18, 20154 Milano</a
          ></p
        >
        <p class="w-700"
          ><a
            href="mailto:info@easycode.org"
            class="text-decoration-none text-reset"
          >
            <img
              src="../../../assets/img/Mail.png"
              class="icon-footer"
              alt="mail"
            />
            info@easycode.org</a
          ></p
        >
        <p class="w-700"
          ><a href="tel:+393407245340" class="text-decoration-none text-reset"
            ><img
              src="assets/img/Phone.png"
              alt="phone"
            />
            Filippo Abirascid
            <span class="dash">- </span>
            <span class="phone"> +39 340 72 45 340</span></a
          ></p
        >
      </div>
    </div>

    <div class="col-lg-6 col-md-12">
      <div class="s-card m-auto p-5 p-xl-5 p-xs-5">
        <div class="col-12 m-0">
          <form [formGroup]="form" class="contact-form">
            <div class="row mt-2 mb-3">
              <div class="col-xl mb-3 mb-xl-0">
                <label for="contact-name">Nome*</label><br />
                <input
                  id="contact-name"
                  class="f-input"
                  type="text"
                  formControlName="name"
                  placeholder="Inserisci il nome"
                  required
                  aria-required="true"
                  autocomplete="given-name"
                />
                <tui-error
                  [formControl]="form.controls.name"
                  [error]="[] | tuiFieldError | async"
                ></tui-error>
              </div>
              <div class="col-xl">
                <label for="contact-surname">Cognome*</label>
                <input
                  id="contact-surname"
                  class="f-input"
                  type="text"
                  formControlName="surname"
                  placeholder="Inserisci il cognome"
                  required
                  aria-required="true"
                  autocomplete="family-name"
                />
                <tui-error
                  [formControl]="form.controls.surname"
                  [error]="[] | tuiFieldError | async"
                ></tui-error>
              </div>
            </div>
            <div class="row mt-2 mb-3">
              <div class="col-12">
                <label for="contact-email">Email*</label>
                <input
                  id="contact-email"
                  class="f-input"
                  type="email"
                  formControlName="email"
                  placeholder="Inserisci email"
                  required
                  aria-required="true"
                  autocomplete="email"
                />
                <tui-error
                  [formControl]="form.controls.email"
                  [error]="[] | tuiFieldError | async"
                ></tui-error>
              </div>
              <div class="row mt-2 mb-3">
                <div class="col-12 mt-2">
                  <label for="contact-message">Il tuo messaggio*</label>
                  <textarea
                    id="contact-message"
                    class="f-textarea"
                    formControlName="message"
                    rows="4"
                    placeholder="Inserisci Messaggio"
                    required
                    aria-required="true"
                    autocomplete="off"
                  ></textarea>
                  <tui-error
                    [formControl]="form.controls.message"
                    [error]="[] | tuiFieldError | async"
                  ></tui-error>
                </div>
              </div>
            </div>

            <div class="row mt-3 mt-xl-3 mb-3">
              <span class="privacy">
                <label class="d-flex align-items-start gap-2">
                  <tui-checkbox
                    formControlName="privacy"
                    size="l"
                    class="tui-space_bottom-3"
                  ></tui-checkbox>
                  <span>
                    Dichiaro di aver letto l'<span style="font-weight: bold;">informativa sulla privacy</span> disposta ai
                    sensi dell'art.13 del Regolamento UE 2016/679 e acconsento al
                    trattamento dei dati personali.
                  </span>
                </label>
              </span>
            </div>

            <div class="row mt-5 mt-xl-0">
              <button
                class="btn-lightblue"
                [disabled]="form.invalid"
                (click)="sendEmail()"
              >
                <ng-container *ngIf="!isLoading">
                  <span class="button-txt">Invia</span>
                </ng-container>
                <ng-container *ngIf="isLoading">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                </ng-container>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="row m-0 p-5"></div>
</div>
